import { ActionReducerMap } from '@ngrx/store';
import * as fromPortfolioGuide from '@store/portfolio-guide/portfolio-guide.reducer';

import * as fromAdminCombinations from './admin-combinations/admin-combinations.reducer';
import * as fromApplication from './application/application.reducer';
import * as fromEducationalSection from './educational-section/educational-section.reducer';
import * as fromEntities from './entities/entities.reducer';
import * as fromReferences from './light-protection-references/light-protection-references.reducer';
import * as fromProductManagers from './product-managers/product-managers.reducer';
import * as fromSystemNotifications from './system-notifications/system-notifications.reducer';
import * as fromUser from './user/user.reducer';
import * as fromUserCombinations from './user-combinations/user-combinations.reducer';

export interface State {
  application: fromApplication.ApplicationState;
  userCombinations: fromUserCombinations.UserCombinationsState;
  user: fromUser.UserState;
  entities: fromEntities.EntitiesState;
  adminCombinations: fromAdminCombinations.AdminCombinationsState;
  lightProtectionReferences: fromReferences.LightProtectionReferencesState;
  systemNotifications: fromSystemNotifications.SystemNotificationsState;
  portfolioGuide: fromPortfolioGuide.PortfolioGuideState;
  productManagers: fromProductManagers.ProductManagersState;
  educationalSection: fromEducationalSection.EducationalSectionState;
}

export const reducers: ActionReducerMap<State, any> = {
  application: fromApplication.applicationReducer,
  userCombinations: fromUserCombinations.userCombinationsReducer,
  user: fromUser.userReducer,
  entities: fromEntities.entitiesReducer,
  adminCombinations: fromAdminCombinations.adminCombinationsReducer,
  lightProtectionReferences: fromReferences.lightProtectionReferencesReducer,
  systemNotifications: fromSystemNotifications.systemNotificationsReducer,
  portfolioGuide: fromPortfolioGuide.portfolioGuideReducer,
  productManagers: fromProductManagers.productManagersReducer,
  educationalSection: fromEducationalSection.educationalSectionReducer
};
